/**
 * The trial-enforcement triggers (migration 0035) raise SQLSTATE 'PT402'.
 * PostgREST surfaces it to supabase-js as error.code, so any mutation blocked
 * because the org's trial expired can be recognised structurally.
 */
const TRIAL_EXPIRED_CODE = "PT402";

export function isTrialExpiredError(error: unknown): boolean {
  return (
    typeof error === "object" &&
    error !== null &&
    "code" in error &&
    (error as { code: unknown }).code === TRIAL_EXPIRED_CODE
  );
}
